import { createSelector } from 'reselect'

const arcCampaignsState = (state) => state.arcCampaigns

export const getArcCampaignsEntities = createSelector(
  arcCampaignsState,
  (state) => state?.entities || {}
)

export const getArcCampaignsSortedIds = createSelector(
  arcCampaignsState,
  (state) => state?.sortedIds || []
)

export const getArcCampaigns = createSelector(
  [getArcCampaignsEntities, getArcCampaignsSortedIds],
  (entities, sortedIds) => sortedIds.map(id => entities[id]).filter(Boolean)
)

export const getIsLoaded = createSelector(
  arcCampaignsState,
  (state) => state?.isLoaded || false
)

export const getPage = createSelector(
  arcCampaignsState,
  (state) => state.page
)

export const getPageCount = createSelector(
  arcCampaignsState,
  (state) => state.pageCount
)

export const getExpandedRows = createSelector(
  arcCampaignsState,
  (state) => state?.expandedRows || []
)

export const getIncludedData = createSelector(
  arcCampaignsState,
  (state) => state.included || []
)

export const getSearchString = createSelector(
  arcCampaignsState,
  (state) => state.search
)

export const getIsSavingActive = createSelector(
  arcCampaignsState,
  (state) => state.isSavingActive
)

export const getFilters = createSelector(
  arcCampaignsState,
  (state) => state?.filters || {}
)

export const getSorter = createSelector(
  arcCampaignsState,
  (state) => state?.sorter || {}
)

export const getIsDataFilteredOrSorted = createSelector(
  [getFilters, getSorter, getSearchString],
  (filters, sorter, search) => {
    const hasFilters = Object.keys(filters).length > 0
    const hasSorter = Object.keys(sorter).length > 0
    const hasSearch = search && search.length > 0
    return hasFilters || hasSorter || hasSearch
  }
)

export const getSelectedCampaign = createSelector(
  arcCampaignsState,
  (state) => state.selectedCampaign
)

export const getCampaignById = createSelector(
  getArcCampaignsEntities,
  (entities) => (campaignId) => entities[campaignId]
)